import { useBooleanState } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useDispatch, useSelector } from 'react-redux'

import { InvitationInfo, MigrationInfo } from 'features/user_info'

import { eventTypeParticipantsSelector, eventTypeSelector } from '../../selectors'
import { setPermissionRole } from '../../slice'
import { RemoveConfirmationModal } from '../remove_confirmation_modal'
import { FlexContainer, MembershipInfoContainer } from '../styles'
import { RoleSelect } from './role_select'
import { FullStoryMask } from '../../../../shared/fullstory_privacy'

export const Invitation = ({ invitation, canRemove, onRemove }) => {
  const dispatch = useDispatch()
  const participants = useSelector(eventTypeParticipantsSelector)
  const participant = participants.find(
    ({ principleType, principleUuid }) => principleType === 'OrganizationInvitation' && principleUuid === invitation.uuid
  )
  const [isRemoveConfirmationModalOpen, openRemoveConfirmationModal, closeRemoveConfirmationModal] = useBooleanState(false)
  const { name: eventTypeName } = useSelector(eventTypeSelector)

  const removeModalTitle = I18n.t('publisher.event_types.edit_hosts_modal.remove_confirmation_modal.title.invitation', {
    email: invitation.email,
    event_type_name: eventTypeName
  })

  const handleRemoveConfirmation = () => {
    onRemove()
    closeRemoveConfirmationModal()
  }

  const changeRole = (value) => dispatch(setPermissionRole({ type: participant.principleType, uuid: participant.principleUuid, value }))

  if (!participant) return null

  return (
    <>
      <FlexContainer>
        <MembershipInfoContainer>
          {invitation.status === 'migrating' ? (
            <MigrationInfo migration={invitation} isAvatarNonInteractive />
          ) : (
            <InvitationInfo invitation={invitation} isAvatarNonInteractive />
          )}
        </MembershipInfoContainer>
      </FlexContainer>
      <RoleSelect
        value={participant.role}
        onChange={changeRole}
        onRemove={canRemove && (() => openRemoveConfirmationModal())}
        onTransfer={null}
      />
      <RemoveConfirmationModal
        isOpen={isRemoveConfirmationModalOpen}
        onClose={closeRemoveConfirmationModal}
        onConfirm={handleRemoveConfirmation}
        title={<FullStoryMask>{removeModalTitle}</FullStoryMask>}
      />
    </>
  )
}
